<template>
  <div class="main" ref="activity_scroll" @scroll="activityScroll">
    <ul class="p-p-menu">
        <li class="p-item" @click="showPlan">
            移液器分类
            <i class="iconfont icon-xiajiantou"></i>
        </li>
        <!-- <li class="p-item" @click="goDetail('secondProduct',112)">移液器筛选<img :src="cdnUrl + 'FiGhRqT9B94EZqMAc7i0K8PinvCc'" alt=""></li> -->
        <li class="p-item" @click="goDetail('sucker')"><img :src="cdnUrl + 'juplus2.0__1665467360_634503e0b7852.png'" alt="">
            吸头筛选
            <i class="iconfont icon-xiajiantou"></i>
        </li>
    </ul>
    <div class="p-b-more" >
        <div class="item-bottom">
          <div class="option" @click="goDetails(item)" v-for="item in proList" :key="item.id">
            <div class="img-cover">
              <van-image :src="cdnUrl+JSON.parse(item.img_url)[0]" fit="cover" alt="" class="img"/>
            </div>
            <div class="product-title ">{{item.title}}</div>
          </div>
        </div>
    </div>
    
    <footerLine></footerLine>
    <van-popup v-model="showPlanVan" position="left" :style="{ height: '100%' }">
        <div class="popup-left-class ">
            <p class="right-sel-btn m-t-10 p-l-20" @click="selPlan(0)">全部</p>
            <p class="right-sel-btn m-t-10 p-l-20" @click="selPlan(item)" v-for="item in planList" :key="item.id">{{ item.title }}</p>
        </div>
    </van-popup>
  </div>
</template>

<script>
import { getAllCategory } from '@/api/product'
import { getProBindList } from '@/api/centrifuge'
import { setPurchaseNum } from '@/api/sucker'
import footerLine from '@/components/footerLine'
export default {
    components: {
        footerLine
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            page: 1,
            planList: [], // 类别
            showPlanVan: false, // 显示类别选择
            cid: 0, // 类别id
            proList: [],
        }
    },
    created() {
        this.getAllCategoryPort()
        this.getProList()
    },
    methods: {
        getProList() { // 列表
            let para = {
                module: '6',
                type: 3,
                page: this.page,
                cid: this.cid || 0
            }
            getProBindList(para).then(res => {
                this.proList.push(...res.data.data)
                this.$toast.clear()
                this.last_page = res.data.last_page
            })
        },
        goDetail(url,id) {
            this.$router.push({
                name: url,
                query: {
                    parent_category_id: id
                }
            })
        },
        showPlan() { // 显示类别
            this.showPlanVan = true
        },
        getAllCategoryPort () { // 获取类别
            getAllCategory({ type: 8 })
                .then(res => {
                    this.planList = res
                })
            .catch(err => {
                this.$toast('获取类别接口失败')
                console.log('获取所有类别接口失败', err)
            })
        },
        selPlan(item) { // 类别筛选
            this.cid = item.id
            this.page = 1
            this.proList = []
            let para = {
                type: 8, // 8 移液器分类
                type_id: item.id,
                uid: this.$store.state.user.id || 0,
                action: 1
            }
            setPurchaseNum(para).then(res => { })// 类别人数，次数记录
            this.getProList()
            this.showPlanVan = false
        },
        goDetails(item) {
            this.$router.push({
                name: 'productDetails',
                query: {
                    id: item.type_id,
                    showid: this.cid
                }
            })
        },
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 25 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.getProList()
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.main {
    height: 100vh;
    overflow: auto;
}
.p-p-menu {
    display: flex;
    justify-content: center;
    margin-top: rem(9);
    font-size: rem(13);
    .p-item {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: 159px;
        height: 34px;
        background: #FFFFFF;
        border-radius: rem(6);
        box-shadow: 0px 2px 6px 0px rgba(102,102,102,0.5);
        img {
            width: rem(16);
            height: rem(16);
        }
    }
    .p-item:nth-child(1) {
        margin: 0 rem(8);
        color: #fff;
        background-color: #6CC5DB;
    }
}
.popup-left-class {
    width: rem(186);
    padding-top: rem(20);
    .right-sel-btn {
        height: rem(35);
        margin-top: rem(10);
        padding-left: rem(20);
        border-bottom: 1px solid #ddd;
        box-sizing: border-box;
        // border-radius: rem(5);
    }
}
.p-b-more {
    border-radius: 4px;
    padding: rem(16) rem(16) 0 rem(16);
    width: 90%;
    margin: 0 auto;
    margin-top: rem(16);
    .item-bottom{
        &:after{
        content: '';
        display: block;
        clear: both;
        }
        .option{
        width: rem(143);
        height: rem(166);
        background: #fff;
        margin-bottom: rem(15);
        padding: rem(20) rem(20) rem(10);
        border-radius: 5px;
        box-shadow: 0px 2px 6px 0px rgba(102,102,102,0.5);
        &:nth-child(odd){
            float: left;
        }
        &:nth-child(even){
            float: right;
        }
        .img-cover{
            width: 100%;
            height: rem(80);
            text-align: center;
            .img{
            width: 100%;
            height: 100%;
            }
        }
        .product-title{
            margin-top: rem(10);
            text-align: center;
            color: #2c2c2c;
            font-size: 12px;
            word-break: break-word;
            /*font-weight: bold;*/
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }
        }
    }
}   

</style>